import { FC } from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { DatasetStatus } from '~/api/types';
import { Tooltip } from '~/components';
import { DatasetInProgress, DatasetLockedRestricted, DatasetLockedSearchable, DatasetReadyForReview } from '~/icons';

// TODO: will add tooltip text here in future
const datasetStatusConfig = {
  [DatasetStatus.READY_FOR_REVIEW]: {
    Icon: <DatasetReadyForReview />,
  },
  [DatasetStatus.IN_PROGRESS]: {
    Icon: <DatasetInProgress />,
  },
  [DatasetStatus.LOCKED_SEARCHABLE]: {
    Icon: <DatasetLockedSearchable />,
  },
  [DatasetStatus.LOCKED_RESTRICTED]: {
    Icon: <DatasetLockedRestricted />,
  },
};

interface DatasetStatusCellProps {
  deidentified: string;
  status: DatasetStatus;
}

const DatasetStatusCell: FC<DatasetStatusCellProps> = ({ status, deidentified }) => {
  const Icon = datasetStatusConfig[status]?.Icon;

  return (
    <Tooltip
      title={
        <Stack direction="row" spacing={2}>
          <Stack>
            <Typography variant="buttonTextSmall">DATASET STATUS</Typography>
            <Typography>{status}</Typography>
          </Stack>
          <Stack>
            <Typography variant="buttonTextSmall">DE-IDENTIFICATION STATUS</Typography>
            <Typography>{deidentified ? 'De-Identified' : 'Not De-Identified'}</Typography>
          </Stack>
        </Stack>
      }
    >
      <Box sx={{ display: 'flex', alignItems: 'center' }}>{Icon || <Typography>{status}</Typography>}</Box>
    </Tooltip>
  );
};

export default DatasetStatusCell;
